<template lang="pug">
  .page
    .title new album.
    album-detail-partial(:editMode="editMode")
    .cta-box(class="h-box space-x-2")
      button.button(type="button" @click="createAlbum") create
</template>

<script>
import {mapActions} from "vuex";
import AlbumDetailPartial from "@/components/partial/album/AlbumDetailPartial.vue";

export default {
  name: "AlbumNewPage",
  components: {AlbumDetailPartial},
  data() {
    return {
      editMode: true,
    };
  },
  created() {
  },
  computed: {

  },
  methods: {
    ...mapActions("album", {
      createAlbum: "createAlbum"
    }),
  },
};
</script>